import React from 'react'

const MobileDesignSection = () => {
    return (
        <div className="window-peek-section screen max-width" style={{ padding: 0 }}>
            <div className='mobile window-peek-images flex flex-col'>
            </div>
        </div>
    )
}

export default MobileDesignSection